export default __webpack_public_path__ + "maps-examples-multiple-shapes-thumbnail-480-89b748faac2f389b655545aa742e7020.webp";